import * as React from 'react';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import { SiteUrls } from '@tableau/shared-urls';
import * as CertificationWatermark from '@tableau/certification-watermark';
import { CertificationCell } from './CertificationCell';
import { IColumnFactoryParameters } from '../ListViewGridColumnGenerator';
import * as Layout from '../../../../common/styles/Layout';
import { IconStyle } from '../../../utils/DataCatalogUtils';
import { DataSource } from '../../../models/SearchResultTypes';
import { UserMapper } from '../../../../common/utils/UserMapper';
import { DataSourceType, HiddenUserStyles } from './DataSourceType';
import { AppUrls } from '../../../../app/AppUrls';
import { MapperHelper } from '../../../../common/utils/MapperHelper';
import { DataQualityIndicator } from './DataQualityIndicator';
import { LinkCell } from './LinkCell';

export function DataSourceNameCell(parameters: IColumnFactoryParameters): React.Factory<BodyCell.Props> {
  return React.createFactory(function DataSourceNameCell(props: BodyCell.Props) {
    const certificationFactory = CertificationCell(parameters.listViewParams.urls, {
      isCertified: (row: DataGrid.Row) => {
        if (row && row.data && row.data.certificationDetails) {
          return row.data.certificationDetails.isCertified;
        }
        return false;
      },
      getTooltipProps: (row: DataGrid.Row, urls: SiteUrls): CertificationWatermark.CertificationTooltipProps => {
        return generateDSCertificationTooltipProps(row.data as DataSource, urls);
      },
    });
    const linkCellFactory = LinkCell(
      parameters.generateLinkForName,
      true,
      parameters.listViewParams.urls,
      parameters.listViewParams.searchTerm,
      parameters.listViewParams.total
    );

    function generateDSCertificationTooltipProps(dataSource: DataSource, urls: AppUrls): CertificationWatermark.CertificationTooltipProps {
      const certifier = dataSource.certificationDetails ? UserMapper.mapOne(dataSource.certificationDetails.certifier) : null;
      return {
        id: dataSource.id,
        certifier: {
          customUserStyle:
            certifier && certifier.isHiddenInternalUser ? (HiddenUserStyles.HiddenUserStyle as React.CSSProperties) : undefined,
          displayName: (certifier && certifier.displayName) || '',
          url: certifier && certifier.domainName ? urls.userUrl(certifier.username, certifier.domainName) : '',
        },
        note:
          dataSource.certificationDetails && dataSource.certificationDetails.certificationNote
            ? dataSource.certificationDetails.certificationNote
            : '',
        date: MapperHelper.toDate(dataSource.lastRefreshedAt || ''),
      };
    }

    return (
      <div className={Layout.flexH} style={{ width: '100%' }}>
        <div className={IconStyle} style={{ paddingLeft: '3px' }}>
          <DataSourceType data={props.row.data as DataSource} urls={parameters.listViewParams.urls}></DataSourceType>
        </div>
        <div className={IconStyle}>{certificationFactory(props)}</div>
        <div className={IconStyle}>
          <DataQualityIndicator data={props.row.data as DataSource} urls={parameters.listViewParams.urls}></DataQualityIndicator>
        </div>
        <div className={IconStyle}>{linkCellFactory(props)}</div>
      </div>
    );
  });
}
